import { matingDesignGetAllForDropdown } from "@/api/mating_design";

const state = {
    matingDesignOptions: null
};

const mutations = {
    GET_ALL_OPTIONS: (state, data) => {
        state.matingDesignOptions = data;
    },
};

const actions = {
    async getAllMatingDesignOptions({ commit }) {
        let res = await matingDesignGetAllForDropdown();
        if (res) {
            commit("GET_ALL_OPTIONS", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/mating_design.js